import { Capacitor } from '@capacitor/core';

/**
 * Área segura (barras do sistema) que vale de verdade.
 *
 * O CSS usa --tc-safe-top / --tc-safe-bottom (theme/variables.css), que vêm de --safe-area-inset-* (injetado pelo
 * SystemBars do Capacitor 8) ou de env(safe-area-inset-*). Em Android com WebView antigo (< 140) a WebView NÃO é
 * desenhada atrás das barras (o Capacitor já põe a margem nativa), mas env() continua informando a altura da barra
 * de status e da barra de navegação: o espaço era contado duas vezes e a barra de abas ficava "flutuando" acima do
 * rodapé (e o topo, mais baixo).
 *
 * Conferência: se a tela inteira (screen) menos a altura da página já é pelo menos o que as insets dizem, as barras
 * estão FORA da WebView → as insets são zeradas. Usa a maior altura já vista na orientação (o teclado aberto encolhe
 * a página e não pode ser confundido com barra). Só no app Android; iOS e navegador seguem o padrão.
 */
const root = document.documentElement;
let maxHeight = { portrait: 0, landscape: 0 };
let probe;

function measuredInsets() {
  if (!probe) {
    probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;left:0;top:0;width:0;height:0;padding-top:var(--tc-safe-top-raw);padding-bottom:var(--tc-safe-bottom-raw)';
    document.body.appendChild(probe);
  }
  const s = getComputedStyle(probe);
  return { top: parseFloat(s.paddingTop) || 0, bottom: parseFloat(s.paddingBottom) || 0 };
}

function check() {
  const landscape = window.innerWidth > window.innerHeight;
  const key = landscape ? 'landscape' : 'portrait';
  maxHeight[key] = Math.max(maxHeight[key], window.innerHeight);
  const screenH = landscape ? Math.min(screen.width, screen.height) : Math.max(screen.width, screen.height);
  const outside = screenH - maxHeight[key]; // altura que a WebView NÃO ocupa (barras desenhadas fora dela)
  const { top, bottom } = measuredInsets();
  // folga de 4 px para arredondamento; sem insets não há o que corrigir
  const consumed = top + bottom > 0 && outside >= top + bottom - 4;
  root.classList.toggle('safe-area-outside', consumed);
}

export const safeArea = {
  init() {
    if (Capacitor.getPlatform() !== 'android') return;
    const run = () => requestAnimationFrame(check);
    run();
    window.addEventListener('resize', run);
    window.addEventListener('orientationchange', () => setTimeout(run, 300));
    // o SystemBars injeta --safe-area-inset-* depois da página carregar
    new MutationObserver(run).observe(root, { attributes: true, attributeFilter: ['style'] });
    setTimeout(run, 1000);
  },
};
